/**
 * Message Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';

export class MessageRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'message';
  }
  
  render(context: ElementRenderContext) {
    return (
      <div 
        style={{
          ...context.elementStyle,
          backgroundColor: '#f0fdf4',
          border: '1px solid #86efac',
          borderRadius: '4px',
        }} 
        className="whitespace-pre-wrap" 
        onClick={context.onClick}
      >
        {context.element.content || 'Nachricht an Kunden...'}
      </div>
    );
  }
}
